import { render, staticRenderFns } from "./PhotoAndLastSeen.vue?vue&type=template&id=0ba321e0&"
import script from "./PhotoAndLastSeen.vue?vue&type=script&lang=js&"
export * from "./PhotoAndLastSeen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports